import AuthorizationHelper from '@auth/services/authorization.helper';
import ModulesHelper from '@core/services/modules.helper';

export const entriesRoutes = [
  {
    path: 'entries',
    name: 'admin-entries',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.entries],
      module: ModulesHelper.ENTRIES_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-entries" */ '@entries/pages/entries/entries.vue'),
  },
  {
    path: 'entry-categories',
    name: 'admin-entry-categories',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.entry_categories],
      module: ModulesHelper.ENTRIES_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-entries" */ '@entries/pages/entry-categories/entry-categories.vue'
      ),
  },
];

export const publicEntriesRoutes = [
  {
    path: 'entry-barcode/:token',
    name: 'public-entry-barcode',
    meta: {
      layout: 'bpc-payment',
      withSidebar: false,
      publicRoute: true,
    },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "public-entry-barcode" */ '@entries/pages/entry-barcode-page.vue'
      ),
  },
];
